export type NoteColor = "#a855f7" | "#3b82f6" | "#22c55e" | "#f97316" | "#ef4444";

export interface MeetingNote {
  id: string;
  timestamp: string;
  text: string;
  title?: string;
  color: NoteColor;
  created_at?: string;
}

export const PRESET_COLORS: { hex: NoteColor; name: string }[] = [
  { hex: "#a855f7", name: "Púrpura" },
  { hex: "#3b82f6", name: "Azul" },
  { hex: "#22c55e", name: "Verde" },
  { hex: "#f97316", name: "Naranja" },
  { hex: "#ef4444", name: "Rojo" },
];
